import { useEffect } from "react";

import { useApi } from "../../hooks/useApi";

export default function useJoinMeeting({ inMeetingDetailsRoute, store, eventSources }) {
  const { joinMeeting } = useApi();

  const firstTimeJoinCondition = !store.isJoining && !store.isJoined && store.userMediaPermissionsGranted;
  const allEventSourcesDefined =
    eventSources.meetingDetailsEventSource && eventSources.participantsEventSource && eventSources.currentUserEventSource;

  useEffect(() => {
    const joinMeetingHandler = async () => {
      if (firstTimeJoinCondition && allEventSourcesDefined) {
        try {
          const response = await joinMeeting(store.meeting.mid);
          store.prepareForJoin(true, response?.result);
        } catch (error) {
          console.error("Error joining meeting", error);
        }
      }
    };

    if (inMeetingDetailsRoute && store.meeting?.status === "started") {
      joinMeetingHandler();
    }
  }, [
    inMeetingDetailsRoute,
    store.isJoining,
    store.isJoined,
    store.userMediaPermissionsGranted,
    store.meeting,
    eventSources.meetingDetailsEventSource,
    eventSources.participantsEventSource,
    eventSources.currentUserEventSource,
  ]);
}
